import { Controller } from 'react-hook-form';
import { TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const DescriptionsTable = ({ name, control, readOnly }: { name: string; control: any; readOnly: boolean }) => {
    const TOTAL_ROWS = 7;

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => {
                const descriptions: string[] = field.value || [];
                const paddedDescriptions = [...descriptions];

                // Ensure 7 rows exist
                while (paddedDescriptions.length < TOTAL_ROWS) {
                    paddedDescriptions.push('');
                }

                const updateDescription = (index: number, newValue: string) => {
                    const updated = [...paddedDescriptions];
                    updated[index] = newValue;
                    field.onChange(updated);
                };

                return (
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Description</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paddedDescriptions.map((desc, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            {readOnly ? (
                                                desc || <span style={{ color: '#aaa' }}>�</span>
                                            ) : (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    value={desc}
                                                    onChange={(e) => updateDescription(index, e.target.value)}
                                                />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                );
            }}
        />
    );
};

export default DescriptionsTable;
